import React from 'react';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'Mi mamá tiene 74 años y desde que empezamos con el sistema cambió algo en ella. La veo más despierta, más presente en las conversaciones. El otro día me acordó ella a mí de un turno que yo había olvidado. Me quedé sin palabras.',
    author: 'Romina G.',
    role: 'Hija · 42 años · Buenos Aires'
  }, {
    text: 'Lo compré para mi papá que vive solo. Me preocupaba que pasara los días sin hacer nada que lo estimule. Ahora tiene su rutina de fichas todos los días y cuando lo llamo me cuenta qué hizo. Es otro.',
    author: 'Martín P.',
    role: 'Hijo · 38 años · Córdoba'
  }, {
    text: 'Lo mejor fue el Tomo 6. Mi abuelo nos contó cosas de su vida que nunca habíamos escuchado. Lloramos todos. Fue el mejor momento familiar que tuvimos en años y encima le hizo muy bien a él contarlo.',
    author: 'Valentina R.',
    role: 'Nieta · 26 años · Rosario'
  }, {
    text: 'Pensé que mi suegra no iba a querer hacerlo. Pero como no parece una terapia sino un juego, lo aceptó enseguida. Ahora nos pide que le dejemos fichas nuevas cuando la visitamos.',
    author: 'Carolina M.',
    role: 'Nuera · 44 años · Mendoza'
  }, {
    text: 'Lo que más me gustó es que lo puede hacer sola. No necesita que yo esté ahí todo el tiempo. Tiene su sistema, sus fichas y su rutina. Y yo sé que está activa aunque no pueda estar todos los días con ella.',
    author: 'Lucas F.',
    role: 'Hijo · 35 años · Santa Fe'
  }];
  return <section className="py-20 px-4 bg-[#EFE4CC] border-y border-orange-200" data-id="element-263">
      <div className="max-w-5xl mx-auto" data-id="element-264">
        <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 text-center mb-12" data-id="element-265">
          LO QUE DICEN LAS FAMILIAS QUE YA LO USAN
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-266">
          {testimonials.map((t, idx) => <div key={idx} className={`bg-white border border-orange-200 rounded-2xl p-8 flex flex-col shadow-sm ${idx === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-267">
              <Quote className="w-8 h-8 text-teal-300 mb-4" data-id="element-268" />
              <p className="text-slate-700 italic mb-6 flex-grow" data-id="element-269">"{t.text}"</p>
              <div className="pt-4 border-t border-orange-100" data-id="element-270">
                <p className="font-bold text-slate-900" data-id="element-271">{t.author}</p>
                <p className="text-sm text-teal-700" data-id="element-272">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}